var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 15.0039C35.35 15.0279 37.706 15.2219 39.242 16.7579C41 18.5159 41 21.3439 41 26.9999V28.9999C41 34.6579 41 37.4859 39.242 39.2439C37.486 40.9999 34.656 40.9999 29 40.9999H13C7.344 40.9999 4.514 40.9999 2.758 39.2439C1 37.4839 1 34.6579 1 28.9999V26.9999C1 21.3439 1 18.5159 2.758 16.7579C4.294 15.2219 6.65 15.0279 11 15.0039",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 27V1M21 1L27 8M21 1L15 8",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/uploadImage.5eff64cdf41966580afb504d2fcf24bd.svg";
export { ForwardRef as ReactComponent };